import { defineStore } from 'pinia'
import type { ICity } from '~/shared/interfaces/main'
import type { IBanner } from '~/shared/interfaces/banners'
import type { INotification } from '~/shared/interfaces/ui/notification'
import type { IVinCatalogs } from '~/shared/interfaces/vin'
import type { IBrand, IBrandCompilationItem } from '~/shared/interfaces/brands'

type TAuthModalType =
  | 'email'
  | 'phone'
  | 'passwordRecovery'
  | 'passwordRecoverySuccess'
interface IMainStore {
  allContentLoaded: boolean
  isBodyFixed: boolean
  isFSSlider: boolean
  sotransCities: ICity[]
  sotransCitySelected: ICity | null
  vinBrandsCatalogs: IVinCatalogs[] | null
  vinBrands: IBrandCompilationItem[] | null
  banners: IBanner[]
  isAuthModal: boolean
  authModalType: TAuthModalType
  isInnModal: boolean
  notifications: INotification[] | null
  titleH1: string | null
  seoAdditionalText: string | null
  brandsSection: IBrand[] | null
  isDeletedUserModal: boolean
  isOneSDied: boolean
  isAuthMessage: boolean
  isBitrixWidgetModal: boolean
}

const useMainStore = defineStore({
  id: 'main-store',
  state: (): IMainStore => {
    return {
      allContentLoaded: true,
      isBodyFixed: false,
      isFSSlider: false,
      sotransCities: [],
      sotransCitySelected: null,
      vinBrandsCatalogs: null,
      vinBrands: null,
      banners: [],
      isAuthModal: false,
      authModalType: 'email',
      isInnModal: false,
      notifications: null,
      titleH1: null,
      brandsSection: null,
      seoAdditionalText: null,
      isDeletedUserModal: false,
      isOneSDied: false,
      isAuthMessage: false,
      isBitrixWidgetModal: false
    };
  },
  actions: {
    setAuthMessageState(state: boolean) {
      this.isAuthMessage = state
    },
    setBrandsSection(brands: IBrand[]) {
      this.brandsSection = brands
    },
    setBitrixModalState(state: boolean) {
      this.isBitrixWidgetModal = state
    },
    setContentLoadingStatus(loadingStatus: boolean) {
      this.allContentLoaded = loadingStatus
    },
    setBodyFixed(state: boolean) {
      this.isBodyFixed = state
    },
    toggleFSSlider(state: boolean) {
      this.isFSSlider = state
    },
    setSotransCities(cities: ICity[]) {
      this.sotransCities = cities
    },
    setSotransCitySelected(city: ICity) {
      this.sotransCitySelected = city
    },
    setVinCatalogs(catalogs: IVinCatalogs[]) {
      this.vinBrandsCatalogs = catalogs
      if (catalogs) {
        const brands = catalogs.map((catalog) => {
          return {
            id: catalog.code,
            title: catalog.name,
            link: `/vin/${catalog.code}`,
          }
        })

        this.vinBrands = brands
      }
    },
    setBanners(banners: IBanner[]) {
      this.banners = banners
    },
    setAuthModalState(state: boolean) {
      this.isAuthModal = state
    },
    setAuthModalType(type: TAuthModalType) {
      this.authModalType = type
    },
    setInnModalState(state: boolean) {
      this.isInnModal = state
    },
    setNotifications(notifications: INotification[] | null) {
      this.notifications = notifications
    },
    setDeletedUserModalState(state: boolean) {
      this.isDeletedUserModal = state
    },
    deleteNotification(index: number) {
      this.notifications?.splice(index, 1)
    },
  },
})

export default useMainStore
